// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import share06Icon from "@/assets/icons/share-06.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Share06IconProps = Omit<IconProps, "name">;

export function Share06Icon(props: Share06IconProps): React.ReactNode {
  return <Icon name={share06Icon} {...props} />;
}
